import { render, staticRenderFns } from "./ElementItem.vue?vue&type=template&id=1920b70f&scoped=true&"
import script from "./ElementItem.vue?vue&type=script&lang=js&"
export * from "./ElementItem.vue?vue&type=script&lang=js&"
import style0 from "./ElementItem.vue?vue&type=style&index=0&id=1920b70f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1920b70f",
  null
  
)

export default component.exports